import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import { useAsgActions } from '../../../../../shared/src/hooks/use-asg-actions.hook';
import { useFilterOptionAvailability } from '../../../hooks/use-filter-option-availability.hook';
import { SubcategoriesActionsDialog } from '../SubcategoriesActionsDialog';
import { SubcategoriesFilterActionSection } from '../SubcategoriesFilterActionSection';
import {
    GtmEventLocation,
    GtmEventComponent,
    GtmEventClickElement
} from '../../../../../shared/src/components/google-tag-manager/enums/gtm-event-enum';
import { GtmService } from '../../../../../shared/src/services/gtm.service';
import { useCurrentVerticalData } from '../../../../../shared/src/hooks/use-current-vertical-data.hook';

export const SubcategoriesFilterActionDialog = ({
    show,
    onClose,
    currentSubcategory,
}) => {
    const { t } = useTranslations();
    const {
        setSubcategoriesFilterAction,
        resetSubcategoriesActions,
    } = useAsgActions();
    const dispatch = useDispatch();
    const { filterOptionsList } = useFilterOptionAvailability();
    const { filterBy } = useSelector(state => state.app.subcategoriesActions);
    const [selectedValues, setSelectedValues] = useState(filterBy);

    useEffect(() => {
        setSelectedValues(filterBy);
    }, [filterBy]);

    const onClickHandler = filterOption => {
        return values => {
            const newValues = {
                ...selectedValues,
                [filterOption]: values,
            };

            setSelectedValues(newValues);
        };
    };

    const handleClose = () => {
        setSelectedValues(filterBy);
        onClose();
    };
    const {
        pamGameVerticalID,
        currentVerticalType,
    } = useCurrentVerticalData();
    const sendFilterGtm = (clickAction) => {
        GtmService.track({
            location: GtmEventLocation.GAME_GRID,
            component: GtmEventComponent.FILTERS,
            click_element: GtmEventClickElement.BUTTON,
            click_action: clickAction,
            game_vertical_id: pamGameVerticalID,
            game_vertical_type: currentVerticalType,
        });
    };
    const handleClear = () => {
        sendFilterGtm('clear filters');
        dispatch(resetSubcategoriesActions('filterBy'));
        onClose();
    };
    const handleApply = () => {
        let clickAction = `filter by ${JSON.stringify(selectedValues)}`;
        sendFilterGtm(clickAction);
        dispatch(setSubcategoriesFilterAction(selectedValues));
        onClose();
    };

    const clearButtonDisabled = filterBy.providers === null || filterBy.providers?.length === 0;
    const applyButtonDisabled = JSON.stringify(filterBy) === JSON.stringify(selectedValues);

    const clearButtonClassName = classNames(
        'asg-subcategories__actions-dialog-footer-button',
        'asg-subcategories__actions-dialog-footer-button--secondary',
        {
            'asg-subcategories__actions-dialog-footer-button--disabled': clearButtonDisabled,
        }
    );
    const applyButtonClassName = classNames(
        'asg-subcategories__actions-dialog-footer-button',
        'asg-subcategories__actions-dialog-footer-button--primary',
        {
            'asg-subcategories__actions-dialog-footer-button--disabled': applyButtonDisabled,
        }
    );

    return <SubcategoriesActionsDialog
        show={show}
        hideCloseButtonOnDesktop={false}
        onClose={handleClose}
        headerTitleContent={t('filters')}
        bodyContent={filterOptionsList.map((filterOption, index) => <SubcategoriesFilterActionSection
            key={`${index}-${filterOption}`}
            option={filterOption}
            values={selectedValues?.[filterOption] || []}
            onOptionClick={onClickHandler(filterOption)}
            currentSubcategory={currentSubcategory}
        />)}
        footerContent={(<>
            <button
                className={clearButtonClassName}
                onClick={handleClear}
                disabled={clearButtonDisabled}
            >
                {t('clear')}
            </button>
            <button
                className={applyButtonClassName}
                onClick={handleApply}
                disabled={applyButtonDisabled}
            >
                {t('apply')}
            </button>
        </>)}
    />;
};
